module.exports = __webpack_public_path__ + "static/media/alert_icon_incorrect.64a71a01.svg";